var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingApproval(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.111,
    height: 34,
    viewBox: "0 0 27.111 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pending_approval",
    "data-name": "Pending approval",
    transform: "translate(-363.944 -250.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "document-svgrepo-com",
    d: "M27.093,9.593a7.33,7.33,0,0,1,1.756,2.126,7.33,7.33,0,0,1,.262,2.745V27.111c0,3.247,0,4.871-1.009,5.88S25.47,34,22.222,34H11.889c-3.247,0-4.871,0-5.88-1.009S5,30.359,5,27.111V9.889c0-3.247,0-4.871,1.009-5.88S8.641,3,11.889,3h5.758a7.328,7.328,0,0,1,2.745.262,7.328,7.328,0,0,1,2.126,1.756Z",
    transform: "translate(360.444 249)",
    fill: "none",
    stroke: "#878a99",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "timer-svgrepo-com_1_",
    "data-name": "timer-svgrepo-com (1)",
    transform: "translate(364.645 256.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M12.355,20.863A7.355,7.355,0,0,0,17.588,8.338L18.856,7.07,17.742,5.956,16.36,7.337a7.311,7.311,0,0,0-3.217-1.143V4.576h2.364V3H9.2V4.576h2.364V6.194A7.311,7.311,0,0,0,8.35,7.337L6.969,5.956,5.854,7.07,7.123,8.338a7.355,7.355,0,0,0,5.233,12.524Zm0-13.134a5.779,5.779,0,1,0,5.779,5.779A5.779,5.779,0,0,0,12.355,7.728Z",
    transform: "translate(0 0)",
    fill: "#878a99",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M12.576,12.678V9H11v5.254h4.2V12.678Z",
    transform: "translate(0.304 0.304)",
    fill: "#878a99",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApproval);
export default __webpack_public_path__ + "static/media/Pending_approval.fb3488ecd16cecb2e89ecef780d348fc.svg";
export { ForwardRef as ReactComponent };